module.exports = __webpack_public_path__ + "static/img/img_logo.76365f75.png";